// extracted by mini-css-extract-plugin
module.exports = {"NavigationItem":"HeaderItem_NavigationItem_1s_Y8","active":"HeaderItem_active_tNJrV"};